import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {
	
}

const actions = {

	getTimeZones : function({ commit }, data){

		return new Promise((resolve, reject) => {
			api.get('admin/timezones', {}).then((res) => {
				resolve(res);
			}).catch((error) => {
				reject(error.response);
			});
		});
	}
}

export default {
	state, 
	actions,
	getters,
	mutations
};


// WEBPACK FOOTER //
// ./src/store/modules/TimeZoneModule.js